import React from "react";
import { useTranslation } from "react-i18next";

const Dot = ({ active = false }) => (
  <span className={`dot ${active ? "dot--active" : ""}`} aria-hidden />
);

function Sidebar({ activeSection, onNavigate }) {
  const { t, i18n } = useTranslation();
  
  const getShortLabel = (key, fullLabel) => {
    if (key === 'nav.resume') {
      // For Resume, use "CV" in Dutch and "R" in English
      return i18n.language === 'nl' ? 'CV' : 'R';
    }
    return fullLabel.charAt(0).toUpperCase();
  };
  
  const items = [
    { label: t('nav.about'), shortLabel: getShortLabel('nav.about', t('nav.about')), id: "about" },
    { label: t('nav.resume'), shortLabel: getShortLabel('nav.resume', t('nav.resume')), id: "resume" },
    { label: t('nav.portfolio'), shortLabel: getShortLabel('nav.portfolio', t('nav.portfolio')), id: "portfolio" },
    { label: t('nav.werkwijze'), shortLabel: getShortLabel('nav.werkwijze', t('nav.werkwijze')), id: "werkwijze" },
    { label: t('nav.contact'), shortLabel: getShortLabel('nav.contact', t('nav.contact')), id: "contact" }
  ];

  return (
    <aside className="sidebar card">
      <ul className="sidebar__list">
        {items.map(({ label, shortLabel, id }) => (
          <li key={id} className="sidebar__item">
            <a
              href={`#${id}`}
              className={`sidebar__link ${activeSection === id ? "is-active" : ""}`}
              onClick={(e) => {
                e.preventDefault();
                onNavigate(id);
              }}
              title={label}
            >
              <Dot active={activeSection === id} />
              <span className="sidebar__label-full">{label}</span>
              <span className="sidebar__label-short">{shortLabel}</span>
            </a>
          </li>
        ))}
      </ul>
    </aside>
  );
}

export default Sidebar;
